<template>
    <div class="d-flex" v-if="variants && colorMap">
        <template v-for="variant in variants">
            <v-sheet
                v-if="variant.colorItem"
                :key="variant.id"
                @mouseover="onSelectVariant(variant)"
                class="pa-1 selected-color-variant-box"
                :class="{ 'highlighted-color-variant': value === variant }"
            >
                <v-sheet
                    :style="{ backgroundColor: colorMap[variant.colorItem.color] }"
                    width="24"
                    height="24"
                    :alt="variant.colorItem.color"
                />
            </v-sheet>
        </template>
    </div>
</template>

<script lang="ts">
import { PropType } from 'vue';
import { Vue } from 'vue-property-decorator';
import { NormalizedVariant } from '../../../Common/NormalizedVariant';

export default Vue.extend({
    name: 'ColorVariants',
    props: {
        value: {
            type: Object as PropType<NormalizedVariant>,
            default: null,
        },
        variants: {
            type: Array as PropType<NormalizedVariant[]>,
            required: true,
        },
        colorMap: {
            type: undefined as PropType<Record<string, string>>,
            required: true,
        },
    },
    methods: {
        onSelectVariant(variant: NormalizedVariant): void {
            this.$emit('input', variant);
        },
    },
});
</script>

<style lang="scss" scoped>
.selected-color-variant-box {
    border: 1px solid transparent;
}

.highlighted-color-variant {
    border-color: #555 !important;
}
</style>
